/**
* @file 运营中心-公司钱包
* */
<template>
  <div id="organizationFlowing">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="1">
        <template slot="label"><i class="el-icon-office-building" style="margin-right:4px"></i>窗口售票</template>
      </el-tab-pane>
      <el-tab-pane name="2">
        <template slot="label"><i class="el-icon-mobile-phone" style="margin-right:4px"></i>移动售票</template>
      </el-tab-pane>
    </el-tabs>



    <div style="height: calc(100% - 50px);">
      <ticketStatisticsWindow v-if="tabAction === '1'" />
      <ticketStatisticsMove v-if="tabAction === '2'" />
    </div>


  </div>
</template>

<script>


export default {
  name: " organizationFlowing", components: {
    ticketStatisticsWindow: () =>
      import("./components/ticketStatisticsWindow.vue"),
    ticketStatisticsMove: () => import("./components/ticketStatisticsMove.vue")
  },
  data() {
    return {
      tabAction: '1',
      show: false
    }
  },
  async created() {

  },
  mounted() {
    this.show = true
  },
  methods: {}
}
</script>

<style lang="less">
.organizationFlowing {
  width: 100%;
  height: 100%;


}
</style>
